
    const isProd = typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.PROD;
    if (!isProd) {
      if (typeof window !== 'undefined' && typeof window.__HMR_CONFIG_NAME__ === 'undefined') {
        window.__HMR_CONFIG_NAME__ = 'vite-hmr';
      }
    }
  